import React from 'react'
import styled from 'styled-components'

import { LargeP, P, MonoP } from 'src/components/shared/text'
import { media } from 'src/utils/style-helper'

const ArrowSVG = styled.svg`
  margin-left: 9px;
  fill: inherit;
  ${media.mobile`
    margin-bottom: -3px;
    height: 26px;
    width: 26px;
  `}
  ${media.tablet`
    height: 18px;
    width: 18px;
  `}
  ${media.desktop`
    height: 24px;
    width: 24px;
  `}
`

const ArrowSVGPath = styled.path`
  fill: inherit;
`

const Button = styled.button`
  background-color: ${(props) =>
    props.bg ? props.bg : props.theme.colors.navy};
  border: 1px solid
    ${(props) => (props.bg ? props.bg : props.theme.colors.navy)};
  color: ${(props) =>
    props.textColor ? props.textColor : props.theme.colors.lightText};
  fill: ${(props) =>
    props.textColor ? props.textColor : props.theme.colors.lightText};
  border-radius: 60px;
  outline: none;
  margin: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 100ms all ease-in-out;
  white-space: pre-wrap;
  width: fit-content;

  ${media.mobile`
    padding: 12px 24px 15px 24px;
  `}
  ${media.desktop`
    padding: 15px 36px 17px 36px;
  `}

  &:hover {
    ${media.desktop`
      transform: scale(1.07);
    `}
  }
`

const StretchBtn = styled(Button)`
  ${media.mobile`
    width: 100%;
    padding: 10px 27px;
  `}
  ${media.tablet`
    width: fit-content;
    padding: 12px 27px 12px 27px;
    font-size: 26px;
  `}
`

const Text = styled(LargeP)`
  line-height: 1 !important;
  ${media.mobile`
    font-size: 20px;
  `}
  ${media.tablet`
    font-size: 24px;
  `}
  ${media.desktop`
    font-size: 24px;
  `}
`

const StretchText = styled(Text)`
  font-family: ${(props) => props.theme.fonts.larsseit.regular};
  font-size: 26px !important;
`

export const SecondaryBtn = styled(Button)`
  background-color: transparent;
  border: 1px solid ${props => props.color || props.theme.colors.navy};
  color: ${props => props.color || props.theme.colors.navy};
  transition: 150ms all ease-in-out;
  & ${ArrowSVGPath} {
    fill: ${props => props.color || props.theme.colors.navy};
  }
`

const SmallSecondaryBtn = styled(SecondaryBtn)`
  ${media.mobile`
    padding: 9px 15px;
  `}
  ${media.tablet`
    height: 45px;
  `}
  ${media.desktop`
    padding: 9px 15px;
  `}
`

const ShopNowBtn = styled(SecondaryBtn)`
  ${media.mobile`
    padding: 9px 16px 7px 16px;
  `}
  ${media.tablet`
    padding: 12px 20px 12px 20px;
    font-size: 20px
  `}
`

const NavBtn = styled(Button)`
  border-radius: 50px;
  border-color: ${(props) => props.theme.colors.navy};
  background-color: ${(props) =>
    props.dark
      ? props.theme.colors.navy
      : props.navDrawer
      ? props.theme.colors.white
      : 'transparent'};
  transition: 200ms all ease-in-out;
  height: fit-content;
  width: fit-content;
  ${media.mobile`
    padding: 9px 24px 7px 24px;
    margin-right: 12px;
  `}
  ${media.tablet`
    height: 45px;
  `}
  ${media.desktop`
    padding: 15px 30px 13px 30px;
    margin-right: 20px;
  `}
  &:hover {
    transform: scale(1);
    background-color: ${(props) =>
      props.dark ? props.theme.colors.white : props.theme.colors.navy};
    border-color: ${(props) =>
      props.navDrawer ? props.theme.colors.white : props.theme.colors.navy};
    ${media.mobile`
      padding: 9px 24px ;
      margin-right: 12px;
    `}
    ${media.tablet`
      height: 45px;
    `}
    ${media.desktop`
      padding: 15px 30px 15px 30px;
      margin-right: 20px;
    `}
    & p {
      font-size: 16px !important;
      color: ${(props) =>
        props.dark ? props.theme.colors.navy : props.theme.colors.lightText};
    }
  }
  & p {
    font-size: 16px !important;
    color: ${(props) =>
      props.dark ? props.theme.colors.lightText : props.theme.colors.navy};
  }
`

const ActionBtn = styled(SecondaryBtn)`
  position: relative;
  background: ${(props) =>
    props.activePath ? props.theme.colors.pink : 'transparent'};
  color: ${(props) =>
    props.activePath ? props.theme.colors.navy : props.theme.colors.slate};
  border: 1px solid
    ${(props) => (props.activePath ? 'transparent' : props.theme.colors.slate)};
  transition: 150ms all ease-in-out;
  line-height: 1 !important;
  margin: 6px;
  &:hover {
    transform: scale(1);
    background-color: ${(props) => props.theme.colors.navy};
    color: ${(props) => props.theme.colors.lightText};
    border-color: ${(props) => props.theme.colors.navy};
    padding: 9px 20px 7px 20px;
  }
  ${media.mobile`
    padding: 9px 20px 7px 20px;
  `}
  ${media.desktop`
    padding: 9px 20px 7px 20px;
  `}
`

const CircleButton = styled(SecondaryBtn)`
  padding: 0 !important;
  border-weight: 2px;
  transform: ${(props) => (props.left ? 'rotate(180deg)' : 'none')};
  ${media.mobile`
    height: 30px;
    width: 30px;
  `}
  ${media.tablet`
    height: 40px;
    width: 40px;
  `}
`

const CategoryClose = styled.span`
  position: absolute;
  transform: translate(0, -50%);
  right: 9px;
  top: 50%;
`

const ArrowIcon = () => (
  <ArrowSVG viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ArrowSVGPath d="M6.8 0L13.5 6.1L6.8 12.2L5.8 11L10.2 7H0V5.2H10.2L5.7 1.2L6.8 0Z" />
  </ArrowSVG>
)

export const PrimaryButton = ({ copy, onClick, arrow, bg, textColor }) => {
  return (
    <Button onClick={onClick} bg={bg} textColor={textColor}>
      <Text>{copy}</Text>
      {arrow && <ArrowIcon />}
    </Button>
  )
}

export const StretchCTAButton = ({ copy, onClick, arrow, bg, textColor }) => {
  return (
    <StretchBtn onClick={onClick} bg={bg} textColor={textColor}>
      <StretchText>{copy}</StretchText>
      {arrow && <ArrowIcon />}
    </StretchBtn>
  )
}

export const SecondaryButton = ({ copy, onClick, arrow }) => {
  return (
    <SecondaryBtn onClick={onClick}>
      <Text>{copy}</Text>
      {arrow && <ArrowIcon />}
    </SecondaryBtn>
  )
}

export const SmallSecondaryButton = ({ copy, onClick, arrow, type, color }) => {
  return (
    <SmallSecondaryBtn type={type || 'button'} color={color} onClick={onClick}>
      <P>{copy}</P>
      {arrow && <ArrowIcon />}
    </SmallSecondaryBtn>
  )
}

export const ShopNowButton = ({ copy, onClick, arrow }) => {
  return (
    <ShopNowBtn onClick={onClick}>
      <Text>{copy}</Text>
      {arrow && <ArrowIcon />}
    </ShopNowBtn>
  )
}

export const NavButton = ({ copy, onClick, dark, navDrawer }) => {
  return (
    <NavBtn onClick={onClick} dark={!!dark} navDrawer={navDrawer}>
      <MonoP>{copy}</MonoP>
    </NavBtn>
  )
}

export const ActionButton = ({ copy, onClick, activePath }) => {
  return (
    <ActionBtn onClick={onClick} activePath={activePath}>
      <MonoP>{copy}</MonoP>
      {activePath && <CategoryClose>×</CategoryClose>}
    </ActionBtn>
  )
}

export const ArrowButton = ({ onClick, label, left = false }) => {
  return (
    <CircleButton onClick={onClick} left={left} aria-label={label}>
      <ArrowIcon />
    </CircleButton>
  )
}
